import { gql } from '@apollo/client';

export const fetchCopyAssistSuggestionsQuery = gql`
  query getCopyAssistSuggestion(
    $count: Int!
    $contentType: MuseContentSuggestContentTypeInput!
    $content: String!
    $maxLength: Int!
    $secondaryContent: String
  ) {
    museContentAssistSuggestions(
      count: $count
      contentType: $contentType
      content: $content
      maxLength: $maxLength
      secondaryContent: $secondaryContent
    ) {
      suggestions
    }
  }
`;

export const fetchCopyAssistMoodsQuery = gql`
  query getCopyAssistMoods($content: [String!]!, $maxLength: Int!) {
    museContentDescribeMoods(content: $content, maxLength: $maxLength) {
      moods
    }
  }
`;
